import { Component, Input, OnInit, OnDestroy, Output, ViewContainerRef, ViewChild, EventEmitter, DoCheck, ElementRef } from '@angular/core';

import { Store } from '@ngrx/store';
import { AppState } from '../store/AppState';
import { TaskService } from './task.service';
import { ActionTypeDTO, TaskDTO } from '../api/plyca-dtos';
import { UserService } from '../user.service';
import { UserPrefs, TasksViewPrefs } from '../api/UserPrefs-dto';
import { ProfileService } from '../../services/profile.services';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { UIService, generateRandomIdentifier } from '../ui.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { Configuration } from '../conf/app.constants';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { PlycaDataService } from '../../services/plyca.service';
import { taskActionsComponent } from './task.actions.component';
import { SortEvent } from 'primeng-lts/api';
import { FormService } from '../components/forms/form.service';
import { HelpService, HelpType } from '../components/common/help/help.service';
import { finalize, switchMap } from 'rxjs/operators';


@Component({
  selector: 'tasksListComponent',
  templateUrl: 'tasksList.template.html',
  providers: [UIService, taskActionsComponent]
})
export class tasksListComponent extends BaseComponent implements OnInit, OnDestroy, DoCheck {

  @Input()
  tasksList: Array<TaskDTO>;
  @Input()
  selectedGroup: any;

  @ViewChild('tareas', { read: ViewContainerRef, static: true })
  tareas: ViewContainerRef;

  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  userPrefs: UserPrefs;

  @Output() rows = new EventEmitter();
  @Output() totalRecords = new EventEmitter();
  @ViewChild('tareas')
  taskTable: any;


  tasksListSinFiltrar: Array<TaskDTO>;
  usuidParam: string;
  inboxIdParam: string;
  readonlyParam = false;
  windowHash: string;
  isModalWindow = false;
  loaded: boolean;
  // Lista de tareas con filtros rapidos (cliente) aplicados

  subFilterText: string;
  cities: Array<any> = [];
  tagsParent: string[];

  // [expandedRowKeys]="keys"
  expandedRowKeys = {};

  constructor(
    elem: ElementRef,
    public userService: UserService,
    public taskService: TaskService,
    public profileService: ProfileService,
    private store: Store<AppState>,
    private _configuration: Configuration,
    private waitService: WaitLoadingService,
    private plycaService: PlycaDataService,
    private uiService: UIService,
    public ref: DynamicDialogRef,
    private formService: FormService,
    private dialogConfig: DynamicDialogConfig,
    private helpService: HelpService,
  ) {
    super();
    this.subscribe(this.store
      .select('userPrefs'),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;

        if (!this.userPrefs.tasksViewPrefs) {
          this.userPrefs.tasksViewPrefs = new TasksViewPrefs();
        }
      });

    this.usuidParam = dialogConfig['usuid'];
    this.inboxIdParam = dialogConfig['inboxId'];
    this.readonlyParam = dialogConfig['readonly'];

    if (dialogConfig['list']) {
      this.isModalWindow = true;
      this.windowHash = generateRandomIdentifier();
      this.tasksList = dialogConfig['list'];
      this.tasksListSinFiltrar = JSON.parse(JSON.stringify(this.tasksList));
      this.waitService.cancelWaiting();
    }


    this.cities = [
      { name: '-', code: '' },
      { name: 'Tipo de expediente', code: 'TIPO_EXP' },
      { name: 'Tipo de tarea', code: 'TIPO_TAREA' },
      { name: 'Tipo de contrato', code: 'TIPO_CONTRATO' },
      { name: 'Expediente', code: 'EXPEDIENTE' },
    ];
  }

  ngOnInit(): void {
    this.loaded = false;
    if (this.isModalWindow) {
      this.subscribe(this.helpService.getStoreTagsObservable().pipe(
        switchMap(
          (storedHelpTags) => {
            this.tagsParent = storedHelpTags;
            return this.helpService.showContextHelpObservable(HelpType.TASK_LIST)
          }
        )));
    }
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        super.ngOnDestroy();
      })));

    super.ngOnDestroy();
  }

  isLoaded() {
    return this.loaded === true;
  }
  isActiveTask(task: TaskDTO) {
    return this.taskService.isActiveTask(task);
  }

  isLockedTask(task: TaskDTO) {
    return this.taskService.isLockedTask(task);
  }

  openTask(task: TaskDTO): void {
    // Si no está en modo consulta desde el mantenimiento de buzones o usuarios
    if (!this.readonlyParam && (!this.inboxIdParam || this.inboxIdParam === undefined)
      && (!this.usuidParam || this.usuidParam === undefined)) {
      if (!this.isLockedTask(task)
        && this.taskService.isActionAvailable(task, ActionTypeDTO.TASK_LOCK)) {
        this.taskService.openTask(task);
      }
    }
  }

  getTaskIcon(task: TaskDTO): string {
    return this.taskService.getTaskIcon(task);
  }
  /*
    showTaskProfile(task: TaskDTO) {
      return this.userPrefs && this.userPrefs.tasksViewPrefs && this.userPrefs.tasksViewPrefs.showProfile && task.profile;
    }
  */
  getTaskProfile(task: TaskDTO): string {
    if (!task.profile) {
      return '';
    }
    let profile = this.profileService.getProfile(task.profile.identifier);
    return profile ? profile.description : '';

  }

  ngDoCheck(): void {
    this.outputCountersData();
  }


  outputCountersData() {
    this.rows.emit(this.taskTable && this.taskTable.bodyTemplate._projectedViews
      ? this.taskTable.bodyTemplate._projectedViews.length : 0);
    this.totalRecords.emit(this.taskTable ? this.taskTable.totalRecords : 0);
  }

  customSort(event: SortEvent) {
    // this.updateRowGroupMetaData(event.field, event.order);
    this.sortTasks(event.field, event.order);
  }

  sortTasks(field?: string, order?) {
    this.tasksList.sort((task1, task2) => {
      if (this.getGroupInfo(task1) < this.getGroupInfo(task2)) {
        return -1;
      }
      if (this.getGroupInfo(task2) > this.getGroupInfo(task2)) {
        return 1;
      }

      if (field) {
        let value1 = task1[field];
        let value2 = task2[field];
        let result = null;

        if (value1 == null && value2 != null) {
          result = -1;
        } else if (value1 != null && value2 == null) {
          result = 1;
        } else if (value1 == null && value2 == null) {
          result = 0;
        } else if (typeof value1 === 'string' && typeof value2 === 'string') {
          result = value1.localeCompare(value2);
        } else {
          result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
        }

        return (order * result);
      } else {
        return 0;
      }
    });
  }

  getGroupInfo(task: TaskDTO): string {
    return this.formService.getNestedProperty(task, this.getGroupField()?.code);
  }

  getGroupField() {
    return this.selectedGroup;
  }

  calculateTaskTotal(name) {
    let total = 0;
    if (this.tasksList) {
      total = this.tasksList.filter(task => this.getGroupInfo(task) === name).length;
    }

    return total;
  }
  expand(task: any, _expand: any) {
    this.expandedRowKeys[this.getGroupInfo(task)] = !_expand;
  }


  public updateFilter() {
    let _searchText: string = this.subFilterText;
    if (!_searchText) {
      _searchText = '';
    }

    this.tasksList = JSON.parse(JSON.stringify(this.tasksListSinFiltrar));

    this.tasksList = this.tasksList.filter((task: TaskDTO) => {
      let taskExpeId = task.division.project.contractFolderId;
      if (!taskExpeId) {
        taskExpeId = '';
      }

      let taskExpeTitle = task.division.project.title;
      if (!taskExpeTitle) {
        taskExpeTitle = '';
      }

      let descExpte = '';
      if (task.division && task.division.name) {
        descExpte = task.division.name;
      }

      let descDivisions = '';
      if (task.division && task.division.name) {
        descDivisions = task.division.name;
        if (
          task.division.parent &&
          task.division.parent.name &&
          task.division.parent.identifier !== '0'
        ) {
          descDivisions += ' - ' + task.division.parent.name;
        }
      }

      // PASO 1. COMPROBAR QUE CUMPLE EL FILTRO DE BUSQUEDA TEXTUAL
      let isValidTask =
        taskExpeId.toLowerCase().indexOf(_searchText.toLowerCase()) !== -1 ||
        !_searchText ||
        (task.description.toLowerCase().indexOf(_searchText.toLowerCase()) !==
          -1 ||
          !_searchText) ||
        (taskExpeTitle.toLowerCase().indexOf(_searchText.toLowerCase()) !==
          -1 ||
          !_searchText) ||
        (descDivisions.toLowerCase().indexOf(_searchText.toLowerCase()) !==
          -1 ||
          !_searchText) ||
        (descExpte.toLowerCase().indexOf(_searchText.toLowerCase()) !== -1 ||
          !_searchText);



      return isValidTask;
    }
    );
  }
}
